import React from "react";
import { Box, Typography, Button } from "@mui/joy";

interface CallToActionCardProps {
  onApplyNow: () => void;
}

const CallToActionCard: React.FC<CallToActionCardProps> = ({ onApplyNow }) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        bgcolor: "white",
        borderRadius: "16px",
        p: { xs: 4, md: 4 },
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        mx: { xs: "auto", md: 0 },
      }}
    > 
      <Button
        size="lg"
        onClick={onApplyNow}
        sx={{
          bgcolor: "#2E2D7E",
          color: "white",
          px: 6,
          py: 2,
          fontSize: "1.125rem",
          fontWeight: 600,
          borderRadius: "12px",
          "&:hover": {
            bgcolor: "#1a1a5e",
          },
        }}
        fullWidth
      >
        RESPOND NOW
      </Button>
    </Box>
  );
};

export default CallToActionCard; 